<template>
  <div class="list-controller">
    <pagination :total="total" />

    <div class="clearfix pt--40px">
      <!-- list-admin-checkbox 엘리먼트는 관리자일경우만 노출 -->
      <!-- v-if="user.level >= $utils.getLevel(boardMeta.roles.delete)" -->
      <div
        class="list-admin-checkbox"
        v-if="user.level >= $utils.getLevel('master1')"
      >
        <button
          class="btn btn--sm border border--gray border--lighten-2"
          type="button"
          @click="$emit('selectAll')"
        >전체선택</button>
        <button
          class="btn btn--sm border border--gray border--lighten-2"
          type="button"
          @click="removeSelected"
        >삭제</button>
      </div>
      <div class="list-btn-controller">
        <button
          class="btn btn--sm black text--white"
          v-if="user.level >= $utils.getLevel(boardMeta.roles.create)"
          type="button"
          @click="$router.push({name: $route.name.startsWith('admin') ? 'adminBoardCreate' : 'boardCreate'})"
        >글 등록</button>
      </div>
    </div>

  </div>
  <!-- <div class="list-controller">
    <div class="list-admin-checkbox">
      <template v-if="user.level >= $utils.getLevel(boardMeta.roles.delete)">
        <button
          class="btn btn--xxxl border border--gray border--lighten-2"
          @click="$emit('selectAll')"
        >전체선택</button>
        <button
          type="button"
          @click="removeSelected"
          class="btn btn--xxxl border border--gray border--lighten-2"
        >선택삭제</button>
      </template>
    </div>

    <pagination :total="total" />

    <div class="list-btn-controller">
      <button
        v-if="user.level >= $utils.getLevel(boardMeta.roles.create)"
        type="button"
        @click="$router.push({name: $route.name.startsWith('admin') ? 'adminBoardCreate' : 'boardCreate'})"
        class="btn btn--xxxl black text--white"
      >글 등록</button>
    </div>
  </div> -->
</template>

<script>
import boardMeta from '../js/boardMeta'
import { mapState } from 'vuex'

export default {
  mixins: [boardMeta],
  props: {
    removeSelected: { type: Function, required: true },
    total: { type: Number, default: 0 }
  },
  computed: {
    ...mapState(['user'])
  },
  components: {
    Pagination: () => import('@/component/ui2/pagination/Pagination')
  }
}
</script>

